/**
 * v3.21-1835 — Explicit "Confirm Call" step for every manual outbound call.
 * `requestCallConfirmation({ name, phone })` resolves true only when the
 * user clicks "Confirm Call"; <ConfirmCallHost/> is mounted once in App.
 */
import { useEffect, useState } from 'react';
import { PhoneOutgoing } from 'lucide-react';
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent,
  AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from './ui/alert-dialog';

let _open = null;

export const requestCallConfirmation = ({ name, phone }) => new Promise((resolve) => {
  if (!_open) { resolve(false); return; }
  _open({ name, phone, resolve });
});

export const ConfirmCallHost = () => {
  const [req, setReq] = useState(null);
  useEffect(() => {
    _open = (r) => setReq((cur) => { if (cur) { r.resolve(false); return cur; } return r; });
    return () => { _open = null; };
  }, []);
  const close = (ok) => { req?.resolve(ok); setReq(null); };
  return (
    <AlertDialog open={!!req} onOpenChange={(o) => { if (!o) close(false); }}>
      <AlertDialogContent data-testid="confirm-call-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="flex items-center gap-2">
            <PhoneOutgoing className="h-5 w-5 text-emerald-600" /> Place this call?
          </AlertDialogTitle>
          <AlertDialogDescription asChild>
            <div className="space-y-1 text-sm">
              <div><span className="font-medium text-slate-700">Recipient:</span> <span data-testid="confirm-call-name">{req?.name || 'Unknown contact'}</span></div>
              <div><span className="font-medium text-slate-700">Number:</span> <span data-testid="confirm-call-phone">{req?.phone}</span></div>
              <div className="text-xs text-slate-500 pt-1">The call is logged to your account with this confirmation.</div>
            </div>
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="confirm-call-cancel" onClick={() => close(false)}>Cancel</AlertDialogCancel>
          <AlertDialogAction data-testid="confirm-call-confirm" className="bg-emerald-600 hover:bg-emerald-700" onClick={() => close(true)}>
            Confirm Call
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default ConfirmCallHost;
